// material-ui
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';

// project import
import NavGroup from './NavGroup';
import menuItem from 'menu-items';
import { useAuth, type UserRole } from 'contexts/AuthContext';

// ==============================|| DRAWER CONTENT - NAVIGATION ||============================== //

export default function Navigation() {
  const { hasRole } = useAuth();

  const navGroups = menuItem.items
    .filter((item) => {
      // menu group 에 requiredRole 이 있으면 그 role 보유자에게만 노출 (09 §6.10).
      const required = (item as { requiredRole?: UserRole }).requiredRole;
      return !required || hasRole(required);
    })
    .map((item) => {
      switch (item.type) {
        case 'group':
          return <NavGroup key={item.id} item={item} />;
        default:
          return (
            <Typography key={item.id} variant="h6" color="error" align="center">
              Fix - Navigation Group
            </Typography>
          );
      }
    });

  return <Box sx={{ pt: 2 }}>{navGroups}</Box>;
}
